import React, { useState, useRef, useEffect } from "react";

const PartThirdTab = ({selectedAnswersPartIII,setSelectedAnswersPartIII}) => {
  
  
  const questionRefs = useRef([]);
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
  const handleAnswerChange = (optionId, number) => {
    setSelectedAnswersPartIII((prevAnswers) => {
      
      const newAnswers = [...prevAnswers];
      
      if (newAnswers.includes(optionId)) {
      
        return newAnswers.filter((id) => id !== optionId);
      } else {
      
        return [...newAnswers, optionId];
      }


    });


      // Automatically scroll to the next question
      const nextQuestionIndex = number; // index starts from 0, id starts from 1
      if (questionRefs.current[nextQuestionIndex]) {
        questionRefs.current[nextQuestionIndex].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

  };
  
  const questions = [
    {
      id: 1,
      text: "Select all you like.",
      options: [
        { id: 56, text: "set goals for myself" },
        { id: 57, text: "build things" },
        { id: 58, text: "read about art or music" },
        { id: 59, text: "have clear instructions to follow" },
        { id: 60, text: "influence or persuade people" },
      ],
    },
    {
      id: 2,
      text: "Select all you like.",
      options: [
        { id: 51, text: "do puzzles" },
        { id: 52, text: "work on cars" },
        { id: 53, text: "express myself in interesting ways" },
        { id: 54, text: "work in teams" },
        { id: 55, text: "organize things like files, offices or activities" },
      ],
    },
    {
      id: 3,
      text: "Select all you like.",
      options: [
        { id: 72, text: "figure out how things work" },
        { id: 73, text: "put things together or assemble models" },
        { id: 74, text: "be creative" },
        { id: 75, text: "pay attention to details" },
        { id: 76, text: "do filing or typing" },
      ],
    },
    {
      id: 4,
      text: "Select all you like.",
      options: [
        { id: 87, text: "be a leader" },
        { id: 88, text: "work outdoors" },
        { id: 89, text: "work in an office" },
        { id: 90, text: "work on math problems" },
        { id: 86, text: "keep records of my work" },
        { id: 92, text: "give speeches" },
      ],
    },
    {
      id: 5,
      text: "Select all you like.",
      options: [
        { id: 82, text: "act in plays" },
        { id: 83, text: "think things through before making decisions" },
        { id: 84, text: "work with numbers or charts" },
        { id: 85, text: "have discussions about issues like politics or current events" },
        { id: 86, text: "keep records of my work" },
      ],
    },
    {
      id: 6,
      text: "Select all you like.",
      options: [
        { id: 61, text: "do experiments" },
        { id: 62, text: "teach or train people" },
        { id: 63, text: "have people solve their own problems" },
        { id: 64, text: "take care of animals" },
        { id: 66, text: "have my day structured" },
      ],
    },
    {
      id: 7,
      text: "Select all you like.",
      options: [
        { id: 67, text: "sell things" },
        { id: 68, text: "do creative writing" },
        { id: 69, text: "work on science majors" },
        { id: 70, text: "take on new responsibilities" },
        { id: 71, text: "heal people" },
      ],
    },
    {
      id: 8,
      text: "Select all you like.",
      options: [
        { id: 77, text: "learn about other cultures" },
        { id: 78, text: "analyze things like problems, situation or trends" },
        { id: 79, text: "play instruments or sing" },
        { id: 80, text: "dream about starting my own business" },
        { id: 81, text: "cook" },
      ],
    },
  ];
  
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className=" parts pl-24 pr-24 question-header text-gray-800 text-left mb-12">
      Your Interests - If you agree with the statement, fill in the circle. Remember, there are no wrong answers!
      </h1>
      <div className="parts container pl-24 pr-24 text-gray-800">
        {questions.map((question) => (
          <div
            key={question.id}
            ref={(el) => (questionRefs.current[question.id] = el)}
            className="p-6 mb-6 bg-white shadow-lg "
          >
            <h2 className="question-text text-gray-700 mb-4 ">
              Question {question.id}: {question.text}
            </h2>
            <div className="grid grid-cols-2 gap-4 partIII">
  {question.options.map((option, optionIndex) => (
    <div className="mb-4" key={optionIndex}>
      <label className="space-x-3 pb-4 text-sm font-medium text-gray-700">
        <div className="option-wrapper"> {/* Wrapper for checkbox and button */}
          <input
            type="checkbox"
            checked={selectedAnswersPartIII.includes(option.id)}
            onChange={() => handleAnswerChange(option.id, question.id)} // Checkbox change handler
            className="form-checkbox h-5 w-5 text-green-500"
          />
          <button
            onClick={() => handleAnswerChange(option.id, question.id)} // Button click handler
            className={`partIII-options text-left py-3 px-6 option-text rounded-lg focus:outline-none transition duration-200 ${
              selectedAnswersPartIII.includes(option.id)
                ? "bg-green-500 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            {optionIndex + 1}. {option.text}
          </button>
        </div>
      </label>
    </div>
  ))}
</div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default PartThirdTab;
